import { Component, computed, input } from '@angular/core';
import { assert } from '../../../../core/assert/assert';

@Component({
  selector: 'app-fuelbar',
  templateUrl: './fuelbar.component.html',
  styleUrl: './fuelbar.component.scss',
  standalone: false,
})
export class FuelbarComponent {
  readonly currentVal = input.required<number>();
  readonly maxVal = input.required<number>();
  readonly thin = input(false);
  readonly width = computed(() => {
    assert(this.maxVal() > 0, 'Maximum value must be greater than 0');

    return (this.currentVal() / this.maxVal()) * 100;
  });
}
